export default "__VITE_ASSET__D1v$YANk__"